import Settings from './settings';

const scale = window.devicePixelRatio || 1;
const nameOffset = scale > 2 ? '@3x' : scale > 1 ? '@2x' : '';

const pinMarkerSymbol = {
  type: 'picture-marker',
  url: `/ui-custom-map-point-selected${nameOffset}.png`,
  width: '32px',
  height: '32px'
};

const pinHoverMarkerSymbol = {
  type: 'picture-marker',
  url: `/ui-custom-map-point-clear-selected${nameOffset}.png`,
  width: '32px',
  height: '32px'
};

export const removePin = () => {
  const { loadedMap } = window;
  if (loadedMap) {
    const prevPinLayer = loadedMap.findLayerById('mis-pin-layer');
    if (prevPinLayer) {
      loadedMap.remove(prevPinLayer);
    }
  }
};

export const addPin = (center: any[], name = 'Your location') => {
  const { loadedMap, loadedMapModules } = window;
  if (loadedMap && loadedMapModules) {
    const { Graphic, GraphicsLayer } = loadedMapModules;
    const pinLayer = new GraphicsLayer({ id: 'mis-pin-layer' });
    const point = {
      type: 'point',
      longitude: center[0],
      latitude: center[1]
    };
    const pin = new Graphic({
      geometry: point,
      symbol: pinMarkerSymbol,
      attributes: {
        name
      }
    });
    pinLayer.add(pin);
    loadedMap.add(pinLayer);
  }
};

export const hoverPin = (
  over: boolean,
  screenPoint: { x: number; y: number },
  text: string = 'Your location'
) => {
  const { loadedMap, loadedView } = window;
  if (loadedMap) {
    const pinLayer = loadedMap.findLayerById('mis-pin-layer');
    if (pinLayer) {
      pinLayer.graphics.forEach((g: any) => {
        g.symbol = over ? pinHoverMarkerSymbol : pinMarkerSymbol;
      });
    }

    if (over) {
      if (loadedView) {
        const existingTooltip = document.getElementById('mls-pin-tooltips');
        loadedView.container.style.cursor = 'pointer';
        if (!existingTooltip) {
          const tooltip = document.createElement('div');
          const tootipTextNode = document.createTextNode(text);
          tooltip.className = 'mls-pin-tooltips';
          tooltip.id = 'mls-pin-tooltips';
          tooltip.style.left = `${screenPoint.x - 100}px`;
          tooltip.style.top = `${screenPoint.y + 20}px`;
          tooltip.appendChild(tootipTextNode);
          loadedView.ui.add(tooltip, 'manual');
        } else {
          existingTooltip.style.left = `${screenPoint.x - 45}px`;
          existingTooltip.style.top = `${screenPoint.y + 20}px`;
        }
      }
    } else {
      if (loadedView) {
        loadedView.container.style.cursor = '';
        loadedView.ui.remove('mls-pin-tooltips');
      }
    }
  }
};

export const zoomToCenter = (center: number[], pinTooltip?: string) => {
  const { loadedView } = window;
  if (loadedView) {
    removePin();
    addPin(center, pinTooltip);
    loadedView.goTo({ center, zoom: Settings.zoomLevel });
  }
};

export const zoomToFeature = (
  extent: any,
  extentRadius: number = 0,
  expand: boolean = true
) => {
  const {
    loadedView,
    loadedMapModules
  }: { loadedView: __esri.MapView; loadedMapModules: any } = window;
  if (loadedMapModules) {
    const { GeometryEngine } = loadedMapModules;
    const bufferExtent = GeometryEngine.geodesicBuffer(
      extent,
      extentRadius,
      'kilometers'
    );

    let bufferExtentVal = bufferExtent.extent;

    if (expand) {
      const newExtent = bufferExtent.extent.clone().expand(1.3);
      bufferExtentVal = newExtent;
    }
    loadedView.goTo(bufferExtentVal);
  }
};

export const calculateArea = (
  geometry: any,
  unit: string = 'square-kilometers'
) => {
  const { loadedMapModules } = window;
  const { GeometryEngine } = loadedMapModules;

  return GeometryEngine.geodesicArea(geometry, unit);
};
